/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { BfAppContext, BfPageStore, BfPageStoreLoadParams } from '@tw/tw-runtime';
import { GiftGiftShoppingLoadParam, GiftGiftShoppingStoreState } from './type';
import {
  ProductGoodsDTO,
  SaleDocOrderRestApiService,
  SaleOrderDTO,
  SaleOrderRestApiService,
  SaleOrderService
} from '@tw/clvip-api-gen';

import { CommonStore } from '@/app/core/store/common/common-store';
import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { navigationRef } from '@tw/tw-runtime-rn';

export class GiftGiftShoppingStore extends BfPageStore<GiftGiftShoppingStoreState> {
  private orderFuncService: SaleOrderService;

  private orderService: SaleOrderRestApiService;
  private orderDocService: SaleDocOrderRestApiService;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'gift/gift-shopping-card-end'
        }
      }
    });
    const api = BfAppContext.getInstance().getApiService();
    this.orderFuncService = new SaleOrderService(api);
    this.orderService = new SaleOrderRestApiService(api);
    this.orderDocService = new SaleDocOrderRestApiService(api);
  }

  protected getInitialState(): GiftGiftShoppingStoreState {
    return {
      orderId: undefined,
      orderData: undefined,
      curActivity: undefined,
      orderGoodsTreeData: undefined,
      isTestMode: false
    };
  }
  async onLoad(param?: GiftGiftShoppingLoadParam): Promise<void> {
    this.setLoading(true);
    console.log('param', param);
    try {
      await CommonStore.getInstance().refreshMyCurActivityOrder();

      const curActivity = await CommonStore.getInstance().getCurrentActivity();
      const myCurActivityOrder: SaleOrderDTO = await CommonStore.getInstance().getMyCurActivityOrder();

      console.log('myCurActivityOrder', curActivity, myCurActivityOrder);

      // 订单信息不全 但是有goodsinfo,只有id
      let orderDoc;
      if (myCurActivityOrder || param?.orderId) {
        orderDoc = await this.orderDocService.info({
          id: myCurActivityOrder?.id ?? param?.orderId
        });
      }

      console.log('orderDoc', orderDoc);

      let orderGoodsTreeData;
      // 工单详情的分组查询返回
      if (myCurActivityOrder && curActivity.choseDeadline && new Date().getTime() > curActivity.choseDeadline) {
        orderGoodsTreeData = await this.orderFuncService.detailByGroup({
          id: myCurActivityOrder.id
        });
      }

      console.log('orderFuncService', orderGoodsTreeData);

      // 合并两个接口返回的order数据
      this.setState({
        orderId: myCurActivityOrder?.id ?? param?.orderId,
        orderData: { ...myCurActivityOrder, ...orderDoc },
        curActivity: curActivity,
        orderGoodsTreeData: orderGoodsTreeData,
        isTestMode: false
      });
    } finally {
      this.setLoading(false);
    }
  }

  // 删除订单
  async reSetOrder(): Promise<void> {
    const confirm = await this.messageService.showConfirm('确定重新选择么?');
    if (!confirm) {
      return;
    }
    this.setLoading(true);
    try {
      const req = await this.orderService.delete({
        id: this.getState().orderData.id
      });

      await CommonStore.getInstance().clearCart(false);
      await CommonStore.getInstance().refreshCurrentActivity();
      await CommonStore.getInstance().refreshMyCurActivityOrder();
      await CommonStore.getInstance().refreshAmountLimit();

      navigationRef.current.navigate(ROUTE_NAMES.HomeIndex, {
        screen: ROUTE_NAMES.GiftGiftMall
      });
    } finally {
      this.setLoading(false);
    }
  }

  // 订单生成出货单测试接口
  async testCreateOrder(): Promise<void> {
    const confirm = await this.messageService.showConfirm('确定订单生成出货单测试接口么');
    if (!confirm) {
      return;
    }
    this.setLoading(true);

    try {
      const curActivity = await CommonStore.getInstance().getCurrentActivity();
      const req5 = await this.orderFuncService.internalInvoice({
        id: curActivity.id
      });
      this.messageService.showSuccess('执行成功');
      this.onLoad();
      console.log('订单生成出货单测试接口', req5);
    } finally {
      //
    }
    this.setLoading(false);
  }

  // 删除订单
  async testDeleteOrder(): Promise<void> {
    const confirm = await this.messageService.showConfirm('确定删除订单么?');
    if (!confirm) {
      return;
    }
    this.setLoading(true);

    try {
      await this.orderDocService.delete({
        id: this.getState().orderId
      });
      this.messageService.showSuccess('执行成功');
      this.onLoad();
    } catch (error) {
      console.log('testDeleteOrder', error);
    } finally {
      //
    }

    this.setLoading(false);
  }

  // TODO: 模拟截止后,出货单模式(测试用)
  async testFinishedOrder(): Promise<void> {
    this.setLoading(true);
    try {
      await CommonStore.getInstance().refreshMyCurActivityOrder();

      const curActivity = await CommonStore.getInstance().getCurrentActivity();
      const myCurActivityOrder: SaleOrderDTO = await CommonStore.getInstance().getMyCurActivityOrder();

      console.log('myCurActivityOrder', curActivity, myCurActivityOrder);

      // 订单信息不全 但是有goodsinfo,只有id
      let orderDoc;
      if (myCurActivityOrder) {
        orderDoc = await this.orderDocService.info({
          id: myCurActivityOrder?.id
        });
      }

      console.log('orderDoc', orderDoc);

      // 工单详情的分组查询返回

      const orderGoodsTreeData = await this.orderFuncService.detailByGroup({
        id: myCurActivityOrder.id
      });

      console.log('orderFuncService', orderGoodsTreeData);

      // 合并两个接口返回的order数据
      this.setState({
        orderId: myCurActivityOrder?.id,
        orderData: { ...myCurActivityOrder, ...orderDoc },
        curActivity: curActivity,
        orderGoodsTreeData: orderGoodsTreeData,
        isTestMode: true
      });
    } finally {
      this.setLoading(false);
    }
  }

  async onGoodClick(id: string) {
    this.routeService.push({
      path: ROUTE_NAMES.GiftGiftInfo,
      query: {
        id: id,
        mode: 'view'
      }
    });
  }
}
